export default __webpack_public_path__ + "static/media/courier.7fcac19a.svg";